const inventoryIcon = `
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 4.5H4.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.50003 7.50098H4.50003" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.50003 10.499H4.50003" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.5 13.5H4.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.5 1.49902H4.49997C3.67154 1.49902 2.99997 2.1706 2.99997 2.99902V14.999C2.99997 15.8274 3.67154 16.499 4.49997 16.499H13.5C14.3284 16.499 15 15.8274 15 14.999V2.99902C15 2.1706 14.3284 1.49902 13.5 1.49902Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.25 1.49902V16.499" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.25 5.25098H15" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.25 9H15" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.25 12.749H15" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

export default inventoryIcon;
